import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Service } from 'src/app/core/jsonapi/service';
import {
    AppInsightsBlock, DatabaseBlock, DatabaseUsersBlock, KillSessionResult, PlatformBlock,
    PlatformHealthResource, SessionsBlock
} from '../_types/platform-health';

/// Consultas del panel de salud. Ninguno de estos endpoints es JSON:API: se llaman con this.http
/// heredado y devuelven JSON normal. Todos pasan por loaderService.skipRequest para que el spinner
/// global no se dispare con las cuatro peticiones que hace el panel al cargar.
@Injectable({
    providedIn: 'root'
})
export class PlatformHealthService extends Service<PlatformHealthResource> {
    public override type = 'platformHealth';
    public override url = 'reporting/platformHealth';

    public getPlatform(period: string): Observable<PlatformBlock> {
        return this.fetchJson<PlatformBlock>(`/platform?period=${period}`);
    }

    public getDatabase(period: string): Observable<DatabaseBlock> {
        return this.fetchJson<DatabaseBlock>(`/database?period=${period}`);
    }

    public getAppInsights(period: string): Observable<AppInsightsBlock> {
        return this.fetchJson<AppInsightsBlock>(`/appInsights?period=${period}`);
    }

    /// Sin periodo: es una foto del momento.
    public getSessions(): Observable<SessionsBlock> {
        return this.fetchJson<SessionsBlock>('/sessions');
    }

    /// Usuarios de la base y sus sesiones abiertas ahora mismo. Sin periodo, misma razón que getSessions.
    public getDatabaseUsers(): Observable<DatabaseUsersBlock> {
        return this.fetchJson<DatabaseUsersBlock>('/databaseUsers');
    }

    /// Corta una sesión de SQL Server. A diferencia de las lecturas de arriba, NO pasa por
    /// skipRequest: es una acción explícita del usuario (con confirmación previa), no una de las
    /// peticiones silenciosas que el panel lanza solo al cargar, así que el spinner global es
    /// apropiado mientras se resuelve.
    public killSession(sessionId: number): Observable<KillSessionResult> {
        const url = this.getAPIUrl() + '/sessions/kill';
        return this.http.post<KillSessionResult>(url, { sessionId });
    }

    /// this.get(id) ya existe en Service<R> para JSON:API; se llama distinto para no chocar con ese
    /// miembro público de la clase base.
    private fetchJson<T>(path: string): Observable<T> {
        const url = this.getAPIUrl() + path;
        this.loaderService.skipRequest(url);
        return this.http.get<T>(url);
    }
}
